import {
  Box,
  BoxProps,
  ButtonNew as Button,
  ColorOptions,
  convertHexToRGBA,
  Spacer,
  Text,
  TextProps,
} from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/core'
import { FC, useEffect, useState } from 'react'
import { ViewStyle } from 'react-native'
import { useLazyApiData, useStores } from '../../data/store'
import { convertAmountToWords, dateConverstion, formatAmount, isIFrame } from '../../utils'
import { pages, windowConfig } from '../../utils/constants'
import { MobileProcessing } from '../PaymentProcesseing/MobileProcessing'

const Review: FC = ({ route }: any) => {
  const {
    theme,
    subscription,
    getCardNumber,
    statementDescriptor,
    subscriptionRuleAmount,
    remarks,
    amount,
    getSubscriptionRule,
    getFrequency,
    updatePaymentMethod,
    confirmPayment,
    returnUrl,
    uniqueWindowId,
  } = useStores((root) => ({
    theme: root.config.merchantTheme,
    subscription: root.merchant.subscription,
    statementDescriptor: root.transaction.statementDescriptor,
    remarks: root.transaction.remarks,
    amount: root.transaction.amount.netAmount,
    getCardNumber: root.getCardNumber,
    confirmPayment: root.confirmPaymentApi,
    getSubscriptionRule: root.getSubscriptionRule,
    subscriptionRuleAmount: root.merchant.subscription.ruleAmountValue,
    returnUrl: root.transaction.getMerchantRedirectingUrl(),
    getFrequency: root.getFrequency,
    updatePaymentMethod: root.transaction.updatePaymentMethod,
    uniqueWindowId: root.config.uniqueWindowId,
  }))

  const navigation = useNavigation()

  const { paymentMode, paymentModeTitle } = route?.params ?? {}

  const [showPaymentProcessModal, setShowPaymentProcessModal] = useState(false)
  const [confirmPaymentApi, { state: confirmPaymentState, data: confirmPaymentData }] = useLazyApiData(confirmPayment)

  const { REACT_APP_URL = '', REACT_APP_ENDPOINT = '' } = process.env

  useEffect(() => {
    if (confirmPaymentState === 'fulfilled') {
      navigation.reset({
        index: 0,
        routes: [{ name: pages.progress }],
      })
    }
  }, [confirmPaymentState, navigation, returnUrl])

  const loadProcessingScreen = () => {
    const loaderUrl = REACT_APP_ENDPOINT
      ? `${REACT_APP_URL}/${REACT_APP_ENDPOINT}/loader.html`
      : `${REACT_APP_URL}/loader.html`
    if (!isIFrame()) {
      window.currentChild = window
    } else {
      window.currentChild = window.open(loaderUrl, `jiopayWindow-${uniqueWindowId}`, windowConfig)
      window.currentChild?.focus()
    }
    setShowPaymentProcessModal(true)
  }

  const onPayClick = () => {
    if (paymentMode === 'UPI') {
      updatePaymentMethod(paymentMode, subscription)
      confirmPaymentApi()
    } else {
      updatePaymentMethod(paymentMode, subscription)
      loadProcessingScreen()
    }
  }

  const style = styles(theme)
  const data = [
    {
      title: 'Product',
      subTitle: statementDescriptor ? statementDescriptor : 'e-Mandate',
    },
    {
      title: 'Payment Mode',
      subTitle: paymentModeTitle,
      secondaryTitle: getCardNumber(paymentMode),
    },
    {
      title: `Subscription Amount (${getSubscriptionRule()})`,
      subTitle: `₹${formatAmount(String(subscriptionRuleAmount))} `,
      secondarySubTitle: `(Paid ${getFrequency(subscription.frequency)})`,
      secondaryTitle: convertAmountToWords(String(subscriptionRuleAmount)),
    },
    {
      title: 'Subscription Period',
      subTitle: `${dateConverstion(subscription.scheduledAt)} - ${dateConverstion(subscription.scheduledEnd)}`,
    },
  ]

  return (
    <Box padding={24} backgroundColor={theme.bodyBgColor as ColorOptions} f={1}>
      {data.map((item) => (
        <>
          <Text {...style.title}>{item.title}</Text>
          <Spacer size={6} />
          <Text {...style.subTitle}>
            {item.subTitle}
            {item.secondarySubTitle && <Text {...style.secondarySubTitle}>{item.secondarySubTitle}</Text>}
          </Text>
          {item.secondaryTitle && (
            <>
              <Spacer size={6} />
              <Text {...style.secondaryTitle}>{item.secondaryTitle}</Text>
            </>
          )}
          <Spacer size={24} />
        </>
      ))}
      <Text {...style.title}>
        {remarks ? remarks : `Your account will be debited Rs ${formatAmount(String(amount))}`}
      </Text>
      <Spacer size={24} />
      <Button
        type={'primary'}
        color={theme.brandColor}
        underlayColor={theme.brandColor}
        hoverColor={theme.brandColor}
        icon={'LOCK'}
        onPress={onPayClick}
        title={`Pay ₹ ${formatAmount(String(amount))}`}
        testID={'paySecureBtn'}
      />
      {showPaymentProcessModal && (
        <MobileProcessing
          setShow={setShowPaymentProcessModal}
          show={showPaymentProcessModal}
          sendCallBackToNative={true}
        />
      )}
    </Box>
  )
}

const styles = (theme: any) => ({
  container: {
    flex: 1,
    justifyContent: 'center',
    paddingTop: 10,
    backgroundColor: convertHexToRGBA(theme.brandColor, 10) as ColorOptions,
    padding: 8,
  } as ViewStyle,
  oval: {
    position: 'absolute',
    width: 220,
    height: 220,
    borderBottomRightRadius: 120,
    borderTopLeftRadius: 120,
    borderTopRightRadius: 120,
    transform: [{ rotate: '90deg' }],
    backgroundColor: convertHexToRGBA(theme.brandColor, 10) as ColorOptions,
  } as ViewStyle,
  modalHeader: {
    direction: 'row',
    align: 'center',
    paddingTop: 40,
    paddingHorizontal: 16,
  } as BoxProps,
  title: {
    fontSize: 12,
    color: convertHexToRGBA(theme.bodyTextColor, 50) as ColorOptions,
  } as TextProps,
  subTitle: {
    fontSize: 14,
    fontFamily: 'JioType-Medium',
    color: theme.bodyTextColor as ColorOptions,
  } as TextProps,
  secondaryTitle: {
    fontSize: 12,
    fontFamily: 'JioType-Medium',
    color: convertHexToRGBA(theme.bodyTextColor, 60) as ColorOptions,
  } as TextProps,
  secondarySubTitle: {
    fontSize: 10,
    color: convertHexToRGBA(theme.bodyTextColor, 50) as ColorOptions,
  } as TextProps,
  iconContainer: {
    underlayColor: convertHexToRGBA(theme?.brandColor, 10),
  } as BoxProps,
})

export { Review }
